export const release = {
    version: "v0.86.4 (beta 2)",
    date: "July 07, 2026",
    path: "/builds/Ascendant_2026-07-07-v086_4-beta_2.zip",
};
